/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_4_TitleInputs */

const en_gc_search_guides_what_is_gridcraft_sections_4_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give your first session one clear goal`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_4_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为第一次使用设定一个明确目标`)
};

/**
* | output |
* | --- |
* | "Give your first session one clear goal" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_4_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_4_title = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_4_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_4_title(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_4_title(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_4_title as "gc.search_guides.what_is_gridcraft.sections.4.title" }